import { polyfill as promisePolyfill } from 'es6-promise';

promisePolyfill();



// WEBPACK FOOTER //
// ./src/initialiser/polyfill.js